var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelfare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9933 14.8633C14.4816 15.3517 14.4816 16.1433 13.9933 16.6308C13.505 17.1192 12.7133 17.1192 12.2258 16.6308L7.37914 11.7842L6.2008 12.9625L10.695 17.4567C11.1833 17.945 11.1833 18.7367 10.695 19.2242C10.2066 19.7125 9.41497 19.7125 8.92747 19.2242L5.0333 15.33C2.56914 12.9258 0.0516357 9.7225 0.0516357 6.67083C0.0516357 3.45416 2.48247 0.837494 5.4683 0.837494C6.9458 0.837494 8.07747 1.38916 8.93914 2.00166L5.90664 5.00833C5.35497 5.55916 5.05164 6.29249 5.05164 7.07166C5.05164 7.85083 5.35497 8.58333 5.90497 9.13333C6.4558 9.68499 7.1883 9.98833 7.9683 9.98833C8.3233 9.98833 8.6658 9.91749 8.98914 9.79749L13.9933 14.8633ZM12.07 7.10833L10.3266 8.83999L15.4183 13.855C15.9066 14.3433 16.6983 14.3433 17.1858 13.855C17.9325 13.1083 17.2933 12.2817 17.2933 12.2817L12.0691 7.10833H12.07ZM14.6 0.885827C13.2383 0.894161 11.945 1.48583 10.9483 2.41416L7.08414 6.25249C6.5958 6.74083 6.5958 7.53249 7.08414 8.01999C7.57247 8.50833 8.36414 8.50833 8.85164 8.01999L12.1066 4.78666L18.5516 11.185C19.5441 9.58333 20.0508 8.08333 20.0508 6.71916C20.0508 3.50249 17.5858 0.885827 14.5991 0.885827H14.6Z",
    fill: "url(#paint0_linear_192_501)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_501",
    x1: 10.0512,
    y1: 0.837494,
    x2: 10.0512,
    y2: 19.5904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelfare);
export default __webpack_public_path__ + "static/media/welfare.0632ad17a66ef592d3f4dd3dd860a5a0.svg";
export { ForwardRef as ReactComponent };